export default {
  moduleTitle: 'Evaluations module',
  selectFilterToUse: 'Select the filter to use',
  selectOption: 'Select an option',
  nameAndDescription: 'Name and description',
  type: 'Type',
  category: 'Category',
  institutional: 'Institutional',
  showOf: 'Show {entity1} of {entity2}',
  welcomeMessage: 'Welcome, {firstName} {lastName}',
  welcomeDescription: 'From this module you can manage, review, and configure evaluations along with their associated instruments. Select a filter to get started.',
}
